// extracted by mini-css-extract-plugin
module.exports = {"resourceSelectDescription":"src-containers-Events-Item-Resources-ResourceSelect-style__resourceSelectDescription--2LhGV"};